module.exports = __webpack_public_path__ + "internal-feedback-1-8e21274e6fa9092132f1f044a839314a.webp";